import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const salaryLoadersSlice = createSlice({
  name: "previousOtherAllowance",

  initialState: {
    currentSalaryLoader: false,
    payHistoryLoader: false,
    govtTaxLoader: false,
    salaryHistoryLoader: false,
  },
  reducers: {
    setCurrentSalaryLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.currentSalaryLoader = payload;
    },
    setPayHistoryLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.payHistoryLoader = payload;
    },
    setGovtTaxLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.govtTaxLoader = payload;
    },
    setSalaryHistoryLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.salaryHistoryLoader = payload;
    },
  },
});

export const {
  setCurrentSalaryLoader,
  setGovtTaxLoader,
  setPayHistoryLoader,
  setSalaryHistoryLoader,
} = salaryLoadersSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default salaryLoadersSlice.reducer;
